const WISHLIST_SELECTOR = '.wishlist-btn, .wishlist-btn-pdp';

const emptySvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <g clip-path="url(#swym-empty-icon)">
    <path fill="currentColor" class="swym-wishlist-collections-icon-heart-unfilled" d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.52 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.52 5.53C4.50226 4.55051 5.83283 4.00047 7.22 4.00047C8.60717 4.00047 9.93774 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21ZM7.22 6C6.79668 5.99808 6.37718 6.08018 5.98581 6.24154C5.59444 6.40289 5.23897 6.6403 4.94 6.94C4.33606 7.54712 3.99704 8.36865 3.99704 9.225C3.99704 10.0814 4.33606 10.9029 4.94 11.51L12 18.58L19.06 11.51C19.6639 10.9029 20.003 10.0814 20.003 9.225C20.003 8.36865 19.6639 7.54712 19.06 6.94C18.4437 6.35771 17.6279 6.0333 16.78 6.0333C15.9321 6.0333 15.1163 6.35771 14.5 6.94L12.71 8.74C12.617 8.83373 12.5064 8.90812 12.3846 8.95889C12.2627 9.00966 12.132 9.0358 12 9.0358C11.868 9.0358 11.7373 9.00966 11.6154 8.95889C11.4936 8.90812 11.383 8.83373 11.29 8.74L9.5 6.94C9.20103 6.6403 8.84556 6.40289 8.45419 6.24154C8.06282 6.08018 7.64332 5.99808 7.22 6Z"></path>
  </g>
  <defs><clipPath id="swym-empty-icon"><rect width="24" height="24" fill="white"></rect></clipPath></defs>
</svg>`;

const fillSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <g clip-path="url(#swym-filled-icon)">
    <path fill="currentColor" class="swym-wishlist-collections-icon-heart-filled" d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.52 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.52 5.53C4.50226 4.55051 5.83283 4.00047 7.22 4.00047C8.60717 4.00047 9.93774 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21Z"></path>
  </g>
  <defs><clipPath id="swym-filled-icon"><rect width="24" height="24" fill="white"></rect></clipPath></defs>
</svg>`;

window.wishlistProducts = window.wishlistProducts || [];
window.swat = window.swat || null;

let wishlistLoaded = false;
let fetchInProgress = false;
let swymInitialized = false;
let listenersAttached = false;
let observerAttached = false;

function getButtons(root = document) {
  return Array.from(root.querySelectorAll(WISHLIST_SELECTOR));
}

function getProduct(button) {
  const productId = Number(button.dataset.productId);
  const variantId = Number(button.dataset.variantId);
  const url = button.dataset.productUrl;

  if (!productId || !variantId || !url) return null;

  return {
    epi: variantId,
    empi: productId,
    du: url,
  };
}

function inWishlist(products, productId, variantId) {
  return products.find((product) => Number(product.empi) === Number(productId) && Number(product.epi) === Number(variantId));
}

function setIcon(button, isFilled) {
  const label = button.querySelector('span')?.outerHTML || '';
  button.innerHTML = `${isFilled ? fillSvg : emptySvg}${button.classList.contains('swym-product-wishlist__link') ? label : ''}`;
  button.setAttribute('aria-pressed', isFilled ? 'true' : 'false');
}

function setMatchingButtons(product, isFilled) {
  getButtons().forEach((button) => {
    const buttonProduct = getProduct(button);
    if (!buttonProduct) return;
    if (buttonProduct.empi !== product.empi || buttonProduct.epi !== product.epi) return;

    setIcon(button, isFilled);
    button.removeAttribute('aria-busy');
  });
}

function updateButton(button) {
  const product = getProduct(button);
  if (!product) return;

  setIcon(button, Boolean(inWishlist(window.wishlistProducts, product.empi, product.epi)));
}

function updateButtons(root = document) {
  getButtons(root).forEach(updateButton);
}

function fetchWishlist() {
  if (!window.swat || fetchInProgress) return;

  fetchInProgress = true;
  wishlistLoaded = false;

  const handleSuccess = (products) => {
    window.wishlistProducts = Array.isArray(products) ? products : [];
    wishlistLoaded = true;
    fetchInProgress = false;
    updateButtons();
  };

  const handleError = (error) => {
    wishlistLoaded = false;
    fetchInProgress = false;
    console.warn('Failed to fetch wishlist products', error);
  };

  if (typeof window.swat.fetch === 'function') {
    window.swat.fetch(handleSuccess, handleError);
    return;
  }

  if (typeof window.swat.fetchWrtEventTypeET === 'function') {
    window.swat.fetchWrtEventTypeET(handleSuccess, 4);
    fetchInProgress = false;
    wishlistLoaded = true;
    return;
  }

  handleError(new Error('Swym fetch API is unavailable'));
}

function handleWishlistClick(event) {
  const button = event.target.closest(WISHLIST_SELECTOR);
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  if (!window.swat) {
    initSwymWishlist(window._swat);
  }

  if (!window.swat) {
    console.warn('Swym is not ready yet');
    return;
  }

  const product = getProduct(button);
  if (!product) return;

  const alreadyInWishlist = inWishlist(window.wishlistProducts, product.empi, product.epi);
  const action = alreadyInWishlist ? 'removeFromWishList' : 'addToWishList';
  const nextState = !alreadyInWishlist;

  window.swat.et = 4;
  button.setAttribute('aria-busy', 'true');
  setMatchingButtons(product, nextState);

  window.swat[action](
    product,
    () => {
      setMatchingButtons(product, nextState);
      fetchWishlist();
    },
    (error) => {
      setMatchingButtons(product, alreadyInWishlist);
      console.warn('Wishlist update failed', error);
    }
  );
}

function handleVariantUpdate(event) {
  const variant = event.detail?.resource;
  const productId = event.detail?.data?.productId;
  const root = event.target instanceof Element ? event.target : document;

  if (!variant?.id) return;

  root.querySelectorAll(WISHLIST_SELECTOR).forEach((button) => {
    if (productId && button.dataset.productId && String(button.dataset.productId) !== String(productId)) return;
    button.dataset.variantId = String(variant.id);
    updateButton(button);
  });
}

function observeDynamicButtons() {
  if (observerAttached) return;
  observerAttached = true;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) updateButtons(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

function attachListeners() {
  if (listenersAttached) return;
  listenersAttached = true;
  document.addEventListener('click', handleWishlistClick, true);
  document.addEventListener('variant:update', handleVariantUpdate);
  observeDynamicButtons();
}

function initSwymWishlist(swat) {
  window.swat = swat || window._swat || window.swat;
  if (!window.swat) return;
  if (swymInitialized) {
    fetchWishlist();
    return;
  }

  swymInitialized = true;
  attachListeners();
  fetchWishlist();
}

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(initSwymWishlist);

attachListeners();
if (window._swat) initSwymWishlist(window._swat);

let swymAttempts = 0;
const swymReadyInterval = window.setInterval(() => {
  swymAttempts += 1;
  if (window._swat || window.swat) {
    initSwymWishlist(window._swat || window.swat);
    window.clearInterval(swymReadyInterval);
  } else if (swymAttempts > 40) {
    window.clearInterval(swymReadyInterval);
  }
}, 250);
